import { api, getBranchOwner, get } from "@config";
import { addressValidator } from "./address-validators";
import { basePersonValidator } from "./base-person-validators";
import { companyDataValidate } from "./company-validator";
export { addressValidator, basePersonValidator, companyDataValidate };

export function getStates(payload, ufCode) {
  const p = (states) => {
    payload(states);
  };
  get(`${api.states}${ufCode ? "?uf_code=" + ufCode : ""}`, p);
}

export function getCityById(id, payload = () => {}) {
  const url = `${api.cities}${id}/`;
  const thisPayload = (resp) => {
    payload(resp);
  };
  get(url, thisPayload);
}

export function searchCities(ufCode, city, payload) {
  const p = (states) => payload(states);
  let url = `${api.cities}?`;
  if (ufCode) {
    url += `uf_code=${ufCode}`;
    if (city.length) url += "&";
  }
  if (city.length) {
    url += `city=${city}`;
  }
  get(url, p);
}



// WEBPACK FOOTER //
// ./src/components/parts/utils/index.jsx